import { AspObject } from '@core_n/asp/AspObject';
import { IP_HIST_COUNT } from './TrackObject';
import * as settings from '@core_n/common/settings';
import * as projConsts from '../common/projConsts';
import * as Consts from '@core_n/common/consts';
import { TracksCoreDrawer } from '@core_n/asp/TracksCoreDrawer';
import { IObjectsPool, IMapMngr } from '@core_n/asp/interfaces';
import { TrackDisplayObject, TrackDataType } from './TrackDisplayObject';
import { DisplayObject } from '@core_n/asp/DisplayObject';

export class TracksDrawer extends TracksCoreDrawer {

  constructor(mapMngr: IMapMngr, objectsPool: IObjectsPool, parentLayer) {
    super(mapMngr, objectsPool, parentLayer);

    for (let i = 0; i < IP_HIST_COUNT; i++) {
      this.typeKeys.push(TrackDataType.IpLine + i, TrackDataType.IpPoly + i);
    }

    // newmi-tbd
    this.dataKeys.push(TrackDataType.IpLine, TrackDataType.IpPoly, TrackDataType.Threat);
    this.typeKeys.push(TrackDataType.IpLine, TrackDataType.IpPoly, TrackDataType.Threat);
    // for (let i = 0; i < IP_HIST_COUNT; i++) {
    //   this.dataKeys.push(TrackDataType.IpLine + i, TrackDataType.IpPoly + i);
    //   this.typeKeys.push(TrackDataType.IpLine + i, TrackDataType.IpPoly + i);
    // }
  }

  // newmi-tbd
  protected addDrawTypes(images) {
    // for (let i = 0; i < IP_HIST_COUNT; i++) {
    //   // Add Line
    //   this.drawMgr.addType(
    //     this.is3D() ? NeWMI.Draw.DrawMgr.Enums.EKinds.Geometry3D : NeWMI.Draw.DrawMgr.Enums.EKinds.Geometry,
    //     TrackDataType.IpLine + i,
    //     {
    //       line: { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha | NeWMI.Draw.DrawMgr.Enums.EProperties.EOLineWidth },
    //     }
    //   );

    //   // Add Poly
    //   this.drawMgr.addType(
    //     this.is3D() ? NeWMI.Draw.DrawMgr.Enums.EKinds.Geometry3D : NeWMI.Draw.DrawMgr.Enums.EKinds.Geometry,
    //     TrackDataType.IpPoly + i,
    //     {
    //       line: { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha | NeWMI.Draw.DrawMgr.Enums.EProperties.EOLineWidth },
    //       fill: { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha },
    //     }
    //   );
    // }

    // Add Main Line
    this.drawMgr.addType(
      this.is3D() ? NeWMI.Draw.DrawMgr.Enums.EKinds.Geometry3D : NeWMI.Draw.DrawMgr.Enums.EKinds.Geometry,
      TrackDataType.IpLine,
      {
        line: { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha | NeWMI.Draw.DrawMgr.Enums.EProperties.EOLineWidth },
      }
    );

    // Add Main Poly
    this.drawMgr.addType(
      this.is3D() ? NeWMI.Draw.DrawMgr.Enums.EKinds.Geometry3D : NeWMI.Draw.DrawMgr.Enums.EKinds.Geometry,
      TrackDataType.IpPoly,
      {
        line: { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha | NeWMI.Draw.DrawMgr.Enums.EProperties.EOLineWidth },
        fill: { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha },
      }
    );

    // Add Main Poly
    this.drawMgr.addType(
      this.is3D() ? NeWMI.Draw.DrawMgr.Enums.EKinds.Geometry3D : NeWMI.Draw.DrawMgr.Enums.EKinds.Geometry,
      TrackDataType.Threat,
      {
        line: { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha | NeWMI.Draw.DrawMgr.Enums.EProperties.EOLineWidth },
        fill: { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOAlpha },
      }
    );

    super.addDrawTypes(images);
  }

  // Periodic refresh
  periodicUpdate(): boolean {
    if (!this.initialized || !this.objectsLayer)
      return false;

    // newmi-tbd

    if (this.drawMgr && this.objectsLayerVisible) {
      let ipDisplayed = settings.userSettings.sysTrackElementsOn[Consts.SYS_TRACK_DISPLAY_ELEMENT_IP];
      let tpDisplayed = settings.userSettings.sysTrackElementsOn[Consts.SYS_TRACK_DISPLAY_ELEMENT_TP];

      // ip shapes
      this.drawMgr.typesVisualProps[TrackDataType.IpLine].visible = ipDisplayed;
      this.drawMgr.typesVisualProps[TrackDataType.IpPoly].visible = ipDisplayed;

      // tp shapes
      this.drawMgr.typesVisualProps[TrackDataType.Threat].visible = tpDisplayed;
    }

    return super.periodicUpdate();
  }

  // Override TracksCoreDrawer
  createDisplayObject(obj: AspObject): DisplayObject {
    return new TrackDisplayObject(obj, this);
  }

}
